/* unplugin-vue-components disabled */import { render } from "./consultModal.vue?vue&type=template&id=6c537535&scoped=true&ts=true"
import script from "./consultModal.vue?vue&type=script&lang=ts"
export * from "./consultModal.vue?vue&type=script&lang=ts"

import "./consultModal.vue?vue&type=style&index=0&id=6c537535&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/test-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c537535"]])

export default __exports__